import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import * as z from "zod";
import { null as zNull } from "zod";
export const createReturnAddress = {
  name: "createReturnAddress" as const,
  input: z.object({
    address: FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
  }),
  output: zNull(),
};
